import React, { Suspense, lazy, useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, NavLink, useLocation } from "react-router-dom";
import "./App.css";
import Banner from "./assets/banner.png";
import Spinner from "./components/Spinner";

// Lazy load de todas as páginas
const Controladoria = lazy(() => import("./pages/Controladoria"));
const Financeiro = lazy(() => import("./pages/Financeiro"));
const Contabil = lazy(() => import("./pages/Contabil"));
const Operacao = lazy(() => import("./pages/Operacao"));
const Qsms = lazy(() => import("./pages/Qsms"));
const Rh = lazy(() => import("./pages/Rh"));
const RelatoriosControladoria = lazy(() => import("./pages/Relatorios-controladoria"));
const RelatoriosFinanceiro = lazy(() => import("./pages/Relatorios-financeiro"));
const RelatoriosContabil = lazy(() => import("./pages/Relatorios-contabil"));

// Componente para detectar mudanças de rota e mostrar loading
function AppContent() {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    // Simula um pequeno delay para mostrar o spinner
    const timer = setTimeout(() => {
      setLoading(false);
    }, 800);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <Suspense fallback={<Spinner />}>
      <Routes>
        <Route path="/" element={<Controladoria />} />
        <Route path="/financeiro" element={<Financeiro />} />
        <Route path="/contabil" element={<Contabil />} />
        <Route path="/operacao" element={<Operacao />} />
        <Route path="/qsms" element={<Qsms />} />
        <Route path="/rh" element={<Rh />}  />
        <Route path="/relatorios-controladoria" element={<RelatoriosControladoria />} />
        <Route path="/relatorios-financeiro" element={<RelatoriosFinanceiro />} />
        <Route path="/relatorios-contabil" element={<RelatoriosContabil />} />
      </Routes>
    </Suspense>
  );
}

function App() { 
  return (
    <Router>
      <div className="App">
        <aside className="sidebar">
          <img className="logo-img" src="https://upload.wikimedia.org/wikipedia/commons/c/cf/New_Power_BI_Logo.svg" alt="Power BI Logo" />
          <h2>PORTAL<br />ANÁLISE DE DADOS <span className="strong">BY CPL</span> </h2>
          <NavLink to="/" className={({isActive}) => isActive ? "menu-button active" : "menu-button"}>
            📊 Controladoria
          </NavLink>
          <NavLink to="/financeiro" className={({isActive}) => isActive ? "menu-button active" : "menu-button"}>
            💰 Financeiro
          </NavLink>
          <NavLink to="/contabil" className={({isActive}) => isActive ? "menu-button active" : "menu-button"}>
            📋 Contábil
          </NavLink>
          <NavLink to="/operacao" className={({isActive}) => isActive ? "menu-button active" : "menu-button"}>
            🔧 Operação
          </NavLink>
          <NavLink to="/qsms" className={({isActive}) => isActive ? "menu-button active" : "menu-button"}>
            📑 QSMS
          </NavLink>
          <NavLink to="/rh" className={({isActive}) => isActive ? "menu-button active" : "menu-button"}>
            👥 RH/DP
          </NavLink>

          <a href="http://intranet.grupoatlantica.com.br/intranet/" className="menu-exit">⬅ Voltar para intranet</a>

        </aside>
      
      
        <main className="main">
          <div className="banner-container">
            <img className="banner" src={Banner} alt="Banner" />
          </div>
          <AppContent />
        </main>
    </div>
    </Router>
  );
}

export default App;
